export default "__VITE_ASSET__626730b8__"